import { render, staticRenderFns } from "./CommunityAppStores.vue?vue&type=template&id=7fb7b44a&scoped=true&"
import script from "./CommunityAppStores.vue?vue&type=script&lang=js&"
export * from "./CommunityAppStores.vue?vue&type=script&lang=js&"
import style0 from "./CommunityAppStores.vue?vue&type=style&index=0&id=7fb7b44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7b44a",
  null
  
)

export default component.exports